// extracted by mini-css-extract-plugin
export var option = "_bp-0";
export var optionCard = "_bp-f";
export var optionContent = "_bp-g";
export var optionIcon = "_bp-i";
export var optionIconBox = "_bp-h";
export var optionLabel = "_bp-j";
export var optionPill = "_bp-m";
export var optionPillBadge = "_bp-p";
export var optionPillIcon = "_bp-n";
export var optionPillLabel = "_bp-o";
export var optionRadio = "_bp-k";
export var optionRadioInner = "_bp-l";
export var optionReveal = "_bp-2";
export var optionRevealDelay0 = "_bp-3";
export var optionRevealDelay1 = "_bp-4";
export var optionRevealDelay10 = "_bp-d";
export var optionRevealDelay11 = "_bp-e";
export var optionRevealDelay2 = "_bp-5";
export var optionRevealDelay3 = "_bp-6";
export var optionRevealDelay4 = "_bp-7";
export var optionRevealDelay5 = "_bp-8";
export var optionRevealDelay6 = "_bp-9";
export var optionRevealDelay7 = "_bp-a";
export var optionRevealDelay8 = "_bp-b";
export var optionRevealDelay9 = "_bp-c";
export var optionSelected = "_bp-1";